var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$classes()},[_c('v-switch',{attrs:{"label":_vm.spec.text,"hide-details":""},on:{"change":_vm.changed},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }